import { render, staticRenderFns } from "./BatchUpdate.vue?vue&type=template&id=b04f0cfe&scoped=true&"
import script from "./BatchUpdate.vue?vue&type=script&lang=js&"
export * from "./BatchUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BatchUpdate.vue?vue&type=style&index=0&id=b04f0cfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04f0cfe",
  null
  
)

export default component.exports